import { getURL } from '../../query';
import { getLaunchAppCommonParams, getLaunchAppEnv, forcePull, trackEvent, getDeepLink, createElement, toVw } from '../utils';
import { getLaunchAppStatus } from '../../webx';
const linkTypeToEventIdMap = {
    1: 'launch_app_passenger_btn_click',
    2: 'launch_app_passenger_btn_click',
    3: 'launch_app_mini_btn_click',
    4: 'launch_app_download_btn_click',
    8: 'launch_app_passenger_btn_click',
};
class InvokeAppHandler {
    constructor(launchAppRes, launchAppConfig) {
        this.launchAppRes = null;
        this.launchAppConfig = null;
        this.timer = null;
        this.pageHideTimer = null;
        this.isClickInvokeApp = false;
        this.isAutoInvokeApp = true;
        this.visibilityHandle = null;
        this.pagehideHandle = null;
        // dom节点相关
        this.rootView = null;
        this.waitTextView = null;
        this.container = null;
        this.waitText = null;
        this.timerText = null;
        this.launchAppRes = launchAppRes;
        this.launchAppConfig = launchAppConfig;
    }
    createBottomUI() {
        // 创建dom节点
        const { rootViewStyle, containerStyle, // 拉端半弹窗样式
        titleTextStyle, // 文案样式
        imgStyle, iconBlockStyle, lineStyle, waitTextViewStyle // 倒计时文案提示样式
         } = bottomUiStyle;
        const { mainDeepLinks, pullDescription } = this.launchAppRes;
        const bottomUiIcon = this.launchAppConfig?.extra?.bottomUiIcon || 'https://ut-static.udache.com/webx/ut/PyKSaY5Qhtp25CyqnYP2y.png';
        let { waitTime } = mainDeepLinks[0];
        const rootView = createElement({ label: 'div', className: 'launch-app-wait-view', style: rootViewStyle });
        const container = createElement({ label: 'div', style: containerStyle });
        const iconImg = createElement({
            label: 'img',
            style: imgStyle,
            props: { src: bottomUiIcon }
        });
        const iconBlock = createElement({ label: 'div', style: iconBlockStyle });
        const titleText = createElement({ label: 'div', style: titleTextStyle, text: '温馨提示' });
        const line = createElement({ label: 'div', style: lineStyle });
        const waitTextView = createElement({ label: 'div', style: waitTextViewStyle });
        const descText = createElement({ label: 'span', style: { textAlign: 'left' }, text: `${pullDescription}` });
        const waitText = createElement({ label: 'span', text: `请稍后...  (${waitTime}/${waitTime}s)` });
        // 记录dom节点
        this.rootView = rootView;
        this.waitTextView = waitTextView;
        this.container = container;
        this.waitText = waitText;
        // 由子到父层级关系依次挂载节点x
        waitTextView.appendChild(descText);
        waitTextView.appendChild(waitText);
        container.appendChild(titleText);
        container.appendChild(iconImg);
        container.appendChild(iconBlock);
        container.appendChild(line);
        container.appendChild(waitTextView);
        rootView.appendChild(container);
        document.body.appendChild(rootView);
        // 埋点：弹窗曝光
        trackEvent('launch_app_force_pull_popup_expose', this.launchAppConfig?.extra?.trackParams || {});
        // 防止冒泡
        container.onclick = function (e) {
            e.stopPropagation && e.stopPropagation();
            // 兼容IE
            e.cancelBubble && (e.cancelBubble = true);
        };
        // 点击蒙层，移除提示
        rootView.onclick = () => {
            this.clearTimer();
            this.removeRootView();
        };
    }
    getResultByAddPageListen() {
        return new Promise((resolve, reject) => {
            if (document.visibilityState === 'hidden') {
                resolve('');
                return;
            }
            const visibilityHandle = () => {
                if (document.visibilityState === 'hidden') {
                    resolve('');
                }
            };
            const pagehideHandle = () => {
                resolve('');
            };
            document.addEventListener('visibilitychange', visibilityHandle);
            window.addEventListener('pagehide', pagehideHandle);
            this.visibilityHandle = visibilityHandle;
            this.pagehideHandle = pagehideHandle;
        });
    }
    getResultBySendRequest() {
        // 倒计时结束后，查询拉端结果，如果拉端失败，展示拉端失败时的view
        let { mainDeepLinks } = this.launchAppRes;
        let { waitTime } = mainDeepLinks[0] || {};
        let time = waitTime;
        const { phone, keyboardToken } = this.launchAppConfig;
        const link = getDeepLink(mainDeepLinks[0] || {});
        return new Promise((resolve, reject) => {
            this.timer = setInterval(async () => {
                this.waitText.innerText = `请稍后... (${--time}/${waitTime}s)`;
                if (time <= 0) {
                    this.clearTimer();
                    const params = {
                        args: {
                            url: getURL(),
                            deeplink: link,
                            phone: phone || '',
                            keyboard_token: keyboardToken || ''
                        },
                        ...getLaunchAppCommonParams()
                    };
                    try {
                        const res = await getLaunchAppStatus(params, getLaunchAppEnv());
                        const { conf: { status } } = res;
                        if (status === 1) {
                            // 拉端成功
                            resolve('');
                        }
                        else {
                            // 拉端失败
                            reject();
                        }
                    }
                    catch (error) {
                        // 拉端失败
                        reject();
                    }
                }
            }, 1000);
        });
    }
    getInvokeAppResult() {
        return Promise.race([this.getResultByAddPageListen(), this.getResultBySendRequest()]);
    }
    clearPageHide() {
        document.removeEventListener('visibilitychange', this.visibilityHandle);
        window.removeEventListener('pagehide', this.pagehideHandle);
    }
    clearTimer() {
        clearTimeout(this.timer);
        clearTimeout(this.pageHideTimer);
        this.timer = null;
        this.pageHideTimer = null;
    }
    setPullFailedView() {
        // 更新提示信息为拉端失败时的提示语
        const { pullFailMsg, pullFailDeepLinks, browser } = this.launchAppRes;
        const { extra } = this.launchAppConfig;
        const waitTextView = this.waitTextView;
        waitTextView.innerHTML = pullFailMsg;
        waitTextView.style.width = toVw('570rpx');
        let linkBtnBoxStyle = {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            margin: '84rpx auto 0 auto',
            width: '671rpx',
            color: '#EF8450',
        };
        if (pullFailDeepLinks.length === 2) {
            linkBtnBoxStyle.justifyContent = 'space-between';
        }
        const isTwoItem = pullFailDeepLinks.length === 2;
        const linkBtnBox = createElement({ label: 'div', style: linkBtnBoxStyle });
        // 遍历数据创建候补拉端方式按钮，并为其添加点击拉端事件
        pullFailDeepLinks.forEach(link => {
            const linkBtnStyle = {
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: isTwoItem ? '321rpx' : '428rpx',
                height: isTwoItem ? '67rpx' : '77rpx',
                borderRadius: isTwoItem ? '34rpx' : '39rpx',
                border: '2rpx solid #EF8450',
                color: '#EF8450'
            };
            const linkBtn = createElement({ label: 'div', className: 'launch-app-btn', style: linkBtnStyle, text: link.buttonText });
            linkBtnBox.append(linkBtn);
            if (this.isSupportWeixinTag(link)) {
                // 动态为组件dom添加上微信开放标签
                const script = document.createElement('script');
                const wrap = createElement({ label: 'div', className: 'wx-launch-wrap' });
                const wxBtn = createElement({ label: 'div', className: 'wx-launch-click-btn' });
                Object.assign(wxBtn.style, {
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    color: '#EF8450',
                    backgroundColor: 'transparent'
                });
                Object.assign(wrap.style, {
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    backgroundColor: 'transparent'
                });
                script.type = 'text/wxtag-template';
                script.appendChild(wxBtn);
                const appid = 'wx7e8eef23216bade2';
                const html = `<wx-open-launch-app style="position:absolute;left:0;top:0;right:0;bottom:0;z-index:99999;backgroundColor:transparent;display:flex;justify-content:center;align-items:center" appid="${appid}" id="wx-launch-btn">${script.outerHTML}</wx-open-launch-app>`;
                wrap.innerHTML = html;
                // 点击上报埋点
                wrap.addEventListener('click', () => {
                    const eventId = linkTypeToEventIdMap[link.linkType];
                    eventId && trackEvent(eventId, this.launchAppConfig?.extra?.trackParams || {});
                }, true);
                linkBtn.appendChild(wrap);
            }
            else {
                linkBtn.onclick = () => {
                    this.isClickInvokeApp = true;
                    // 如果点击口令拉端按钮，关闭该弹窗
                    if (link.linkType === 6) {
                        this.clearTimer();
                        this.pageHideTimer();
                        this.rootView.remove();
                    }
                    const eventId = linkTypeToEventIdMap[link.linkType];
                    eventId && trackEvent(eventId);
                    forcePull(link, browser, extra);
                };
            }
        });
        this.container.appendChild(linkBtnBox);
    }
    autoInvokeApp() {
        const { pullFailDeepLinks, browser } = this.launchAppRes;
        const { extra } = this.launchAppConfig;
        const pullFailItem = pullFailDeepLinks[0] || {};
        const { waitTime } = pullFailItem;
        this.pageHideTimer = setTimeout(() => {
            // 清除定时器 & 清除页面监听
            this.clearTimer();
            this.clearPageHide();
            if (!this.isClickInvokeApp) {
                // 自动拉端
                forcePull(pullFailItem, browser, extra);
            }
        }, Number(waitTime) * 1000);
    }
    removeRootView() {
        this.rootView.remove();
    }
    isSupportWeixinTag(linkObj) {
        const { isUseWeixinTag } = this.launchAppConfig;
        return linkObj?.linkType === 8 && isUseWeixinTag && window?.wx;
    }
}
const bottomUiStyle = {
    // 底部弹层样式
    rootViewStyle: {
        position: 'fixed',
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, .6)',
        zIndex: 9999,
        top: 0,
        left: 0
    },
    // 拉端半弹窗样式
    containerStyle: {
        position: 'fixed',
        bottom: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        boxSizing: 'border-box',
        width: '750rpx',
        height: '500rpx',
        backgroundColor: '#FFFFFF',
        textAlign: 'center',
        borderRadius: '40rpx 40rpx 0 0'
    },
    // 文案样式
    titleTextStyle: {
        color: '#353535',
        fontWeight: 'bold',
        marginLeft: '79rpx',
        marginTop: '99rpx',
        fontSize: '42rpx',
        fontFamily: 'Source Han Sans CN'
    },
    imgStyle: {
        position: 'absolute',
        bottom: '343rpx',
        right: '3rpx',
        width: '309rpx',
        height: '276rpx'
    },
    iconBlockStyle: {
        position: 'absolute',
        left: '308rpx',
        top: '27rpx',
        width: '135rpx',
        height: '7rpx',
        backgroundColor: '#DBDBDB',
        borderRadius: '4rpx'
    },
    lineStyle: {
        width: '670rpx',
        height: '1rpx',
        marginTop: '35rpx',
        marginLeft: '47rpx',
        backgroundColor: '#E5E5E5'
    },
    // 倒计时文案提示样式
    waitTextViewStyle: {
        display: 'flex',
        flexDirection: 'column',
        width: '254rpx',
        color: '#717171',
        textAlign: 'left',
        fontSize: '34rpx',
        fontWeight: '400',
        marginLeft: '81rpx',
        marginTop: '34rpx'
    }
};
const showLaunchAppUi = (launchAppRes, launchAppConfig) => new Promise((resolve, reject) => {
    const { isAutoInvokeApp } = launchAppConfig;
    const invokeAppHandle = new InvokeAppHandler(launchAppRes, launchAppConfig);
    // 展示ui弹层
    invokeAppHandle.createBottomUI();
    // 获取拉端结果
    invokeAppHandle.getInvokeAppResult().then(() => {
        // 首拉端成功 - 清除事件监听 & 定时器 & 移除dom
        invokeAppHandle.clearTimer();
        invokeAppHandle.clearPageHide();
        invokeAppHandle.removeRootView();
        resolve();
    }).catch(() => {
        // 首拉端失败
        invokeAppHandle.setPullFailedView();
        // 支持自动拉端
        const { pullFailDeepLinks } = launchAppRes;
        const linkObj = pullFailDeepLinks[0];
        const isUseWeixinTag = invokeAppHandle.isSupportWeixinTag(linkObj);
        if (isAutoInvokeApp && !isUseWeixinTag) {
            invokeAppHandle.autoInvokeApp();
        }
        reject();
    });
});
export default showLaunchAppUi;
